import * as Interfaces from '../interfaces/table';

export class TablePaging implements Interfaces.TabelPaging {
    public constructor() {

        this.sorted = true;
        this.offset = 0;
        this.pageNumber = 0;
        this.pageSize = 0;
        this.paged = false;
        this.totalPages = 0;
        this.totalElements = 0;
        this.last = false;
        this.first = false;
        this.empty = false;
        this.pagingList=[];
    }

    sorted: boolean;
    offset: number;
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    totalPages: number;
    totalElements: number;
    last: boolean;
    first: boolean;
    empty: boolean;
    pagingList:number[];
}
